import React from "react";

const Footer = () => {
  return (
    <footer className="dhs-footer">
      <p>© 2024 Dan&apos;s Handyman Services. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
